import useEventCallback from '@unifyapps/hooks/useEventCallback';
import { useOfflineModeDatabase } from '../../../../../offline-mode/components/context';
import type { ActionHandlerType } from '../../../../context/ActionsProvider/context';
import { SHOULD_NOT_PROPAGATE_UP } from '../../const';

export enum OfflineOperation {
  Sync = 'sync',
  Reset = 'reset',
}

export function useControlOfflineMode() {
  const { syncDatabase, clearDatabase } = useOfflineModeDatabase();

  const onControlOfflineMode: ActionHandlerType = useEventCallback(async (args) => {
    const operation = args.action.payload?.operation as OfflineOperation;

    switch (operation) {
      case OfflineOperation.Sync:
        if (!syncDatabase) {
          console.warn('[ControlOffline] Offline mode is not enabled');
          return Promise.resolve(SHOULD_NOT_PROPAGATE_UP);
        }
        await syncDatabase();
        return Promise.resolve(SHOULD_NOT_PROPAGATE_UP);
      case OfflineOperation.Reset:
        if (!clearDatabase) {
          console.warn('[ControlOffline] Offline mode is not enabled');
          return Promise.resolve(SHOULD_NOT_PROPAGATE_UP);
        }
        await clearDatabase();
        return Promise.resolve(SHOULD_NOT_PROPAGATE_UP);

      default:
        console.warn(`[ControlOffline] Unknown operation: ${operation}`);
        return Promise.resolve(SHOULD_NOT_PROPAGATE_UP);
    }
  });

  return { onControlOfflineMode };
}

export default useControlOfflineMode;
